import utils from "./utils";

const apiVersion = 2; // 新版本添加验签参数，有效值为2
const utility = require("utility");
const device = (() => {
	let string = '';
	const UA = window.navigator.userAgent.toLocaleLowerCase();

	if (UA.indexOf('micromessenger') >= 0) { // 微信
		string = 'WeChat';
	}

	if (UA.indexOf('mac') >= 0) { // mac
		if (UA.indexOf('kidslearning_inapp_web') >= 0) {
			string = 'Mac-Client';
		} else {
			string = 'Mac-Web';
		}
	} else {
		if (UA.indexOf('kidslearning_inapp_web') >= 0) {
			string = 'Windows-Client';
		} else {
			string = 'Windows-Web';
		}
	}

	return string;
})();

export const calculation = (id, login_from) => {
	if (!utils.getCookie("uuid")) {
		utils.setCookie(
			"uuid",
			utils.getUUID(),
			720000,
			window.location.hostname,
			"/"
		);
	}

	const uuid = utils.getCookie("uuid");  //"10.10.39.120";
	const putaoid = id ? id.toString() : "";
	const ts = new Date().getTime();
	const key = uuid + putaoid + ts + getKey();
	const sign = utility.md5(key);

	return {
		uuid,
		putaoid,
		sign,
		ts,
		from: login_from ? login_from : "pc"
		// utils.getHashQueryString('login_from') ? utils.getHashQueryString('login_from') : "pc"
	};
};

const getKey = () => {
	// const str = "com.abc.putao.nb";
	const str = "dl.putaoabc.com";
	return utility.md5(str);
};

export const ParamsStr = function (login_from, id) {
	const params = calculation(id ? id : null, login_from);

	// return `&uuid=${params.uuid}&putaoid=${params.putaoid}&ts=${params.ts
	//   }&sign=${params.sign}&from=${params.from}`;
	return `&uuid=${params.uuid}&putaoid=${params.putaoid}&ts=${params.ts
		}&sign=${params.sign}&from=${params.from}&device=${device}${(params.from === "pc" && apiVersion) ? "&apiVersion=" + apiVersion : ""}`;
}

export const getParamsObj = function (login_from) {
	const params = calculation(utils.getCookie("putaoid"), login_from);
	const token = utils.getCookie("token");
	let useInfo = {
		"putaoid": params.putaoid,
		"token": token,
		"uuid": params.uuid,
		"ts": params.ts,
		"sign": params.sign,
		"from": params.from,
		"device": device,
	}

	if (params.from === "pc" && apiVersion) {
		useInfo.apiVersion = apiVersion; // 用户最多使用设备管理用
	}

	return useInfo;
}

export const getParamsStr = function (login_from) {
	const params = calculation(utils.getCookie("putaoid"), login_from);
	const token = encodeURIComponent(utils.getCookie("token"));

	// return `&uuid=${params.uuid}&putaoid=${params.putaoid}&token=${token}&ts=${params.ts}&sign=${params.sign}&from=${params.from}`;
	return `&uuid=${params.uuid}&putaoid=${params.putaoid}&token=${token}&ts=${params.ts}&sign=${params.sign}&from=${params.from}&device=${device}${(params.from === "pc" && apiVersion) ? "&apiVersion=" + apiVersion : ""}`;
}



// WEBPACK FOOTER //
// ./src/lib/InterfaceCalculation.js